module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_vm._v("DRAMATIS PERSONAE")])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('p', {
    staticClass: "fma"
  }, [_c('i', [_vm._v("(in order of appearance)")])]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Huun-Huur-Tu")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1b"
  }, [_vm._v("Four-person musical group from Tuva, whose members include:")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2"
  }, [_vm._v("Sayan Bapa")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2"
  }, [_vm._v("Anatoli (Tolya) Kuular*")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2"
  }, [_vm._v("Kaigal-ool Xovalyg")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2b"
  }, [_vm._v("Alexei Saryglar")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Alexander Cheparukhin")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Huun-Huur-Tu’s manager")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Eduard Alekseyev")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Russian-Sakha specialist in Siberian music who participated in 1987–1988 Tuva expeditions")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Zoya Kyrgys")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan folklorist and expert on "), _c('i', [_vm._v("xöömei")]), _vm._v(" (throat-singing) who participated in 1987–1988 Tuva expeditions")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Idamchap Xomushtu")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan stringed instrument and jew’s harp player; important informant of Valentina Süzükei")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Alexander Bapa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Former member of Huun-Huur-Tu; brother of Sayan Bapa")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Anya Xovalyg")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Kaigal-ool’s wife")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Sengedorj")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Mongolian musician and outstanding throat-singer from Hovd City")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Tserendavaa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Mongolian musician from Chandman Sum, Hovd Aimag")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Tumat Kara-ool")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Throat-singer recorded for Smithsonian Folkways release later licensed for television commercial")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_vm._v("Joel Gordon")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Recording engineer and radio producer from Boston who participated in Tuvan and Mongolian field research")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("David Harrison")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Linguist and advocate for preservation of endangered languages; specialist in Tuvan language and culture")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Sarymai Orchimaev")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_c('i', [_vm._v("Kai")]), _vm._v(" singer and multi-instrumentalist from the Altai Republic")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Sat Maar-ool")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Throat-singer and teacher from Teeli, in western Tuva")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Narantsogt")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Elderly "), _c('i', [_vm._v("tsuur")]), _vm._v(" (reed flute) player in Hovd Aimag, western Mongolia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Gombojav")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_c('i', [_vm._v("Tsuur")]), _vm._v(" player from Hovd City, son of Narantsogt")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Albert Saspyk-ool")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Expert mimic of animal sounds from Chyraa-Bajy, Tuva")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Alexander Tülüsh")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Hunter who imitated sound and movement of wolves and other animals")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Aldyn-ool Sevek")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Throat-singer and school teacher from Kyzyl-Xaya, in western Tuva")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Grigori Mongush")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan musician who transforms visual landscapes into whistled sound sketches")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Evgeni Ulugbashev")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Xakas singer who performs on the "), _c('i', [_vm._v("chatxan")]), _vm._v(" (zither) and composes songs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Nurlanbek Nyshanov")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Kyrgyz multi-instrumentalist, leader of Ensemble Tengir-Too")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Abdulhamit Raimbergenov")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Kazakh "), _c('i', [_vm._v("dombra")]), _vm._v(" (long-necked lute) player and music educator")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Ruslan Jumabaev")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Kyrgyz "), _c('i', [_vm._v("komuz")]), _vm._v(" (long-necked lute) virtuoso")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Namazbek Uraliev")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Kyrgyz "), _c('i', [_vm._v("komuz")]), _vm._v(" virtuoso")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Deleg Bayansair")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan singer in Tsengel Sum, western Mongolia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Mongush Kenin-Lopsan")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan scholar of shamanism, writer, and cultural revivalist")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Dari Bandi")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Mongolian singer and herder, expert at using sound to manage herd animals")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_vm._v("Vyacheslav Kuchenov")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Xakas musician and epic composer, member of ensemble Sabjilar")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Sergei Charkhov")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Xakas musician and instrument builder, member of ensemble Sabjilar")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Anya Burnakova")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Xakas musician, member of ensemble Sabjilar")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Lazo Mongush")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan shaman")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Kara-ool Dopchuur")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan shaman")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Ai-Churek Oyun")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan shamaness")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Rysbek Jumabaev")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Kyrgyz "), _c('i', [_vm._v("manaschi")]), _vm._v(" (epic singer)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Tyva Kyzy")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1b"
  }, [_vm._v("Female throat-singing group from Tuva whose members include:")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2"
  }, [_vm._v("Choduraa Tumat")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2"
  }, [_vm._v("Ailangmaa Damyrang")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2"
  }, [_vm._v("Ailang Ondar")]), _vm._v(" "), _c('p', {
    staticClass: "tabh2b"
  }, [_vm._v("Shoraana Kuular")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Raisa Modorova")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Altai singer-songwriter and performer of "), _c('i', [_vm._v("kai")]), _vm._v(" (guttural) vocal style")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Kongar-ool Ondar")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Tuvan throat-singer and informal cultural ambassador")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Svetlana Bapa")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Wife of Huun-Huur-Tu member Sayan Bapa")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Ross Daly")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Irish musician and world music impresario who resides on Crete")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Manos Andriotis")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Greek music producer and world music fan")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Jamchid Chemirani")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabh1"
  }, [_vm._v("Iranian percussionist who performed with Huun-Huur-Tu in Greece")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a198f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_FM02.vue
// module id = 81
// module chunks = 0